import { render } from "./SobreNosView.vue?vue&type=template&id=35288a48&scoped=true"
import script from "./SobreNosView.vue?vue&type=script&lang=js"
export * from "./SobreNosView.vue?vue&type=script&lang=js"

import "./SobreNosView.vue?vue&type=style&index=0&id=35288a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35288a48"]])

export default __exports__